import { render } from "./FrmPlannedOrdersPalletizingPoint.vue?vue&type=template&id=0b6cef2a"
import script from "./FrmPlannedOrdersPalletizingPoint.vue?vue&type=script&lang=js"
export * from "./FrmPlannedOrdersPalletizingPoint.vue?vue&type=script&lang=js"

import "./FrmPlannedOrdersPalletizingPoint.vue?vue&type=style&index=0&id=0b6cef2a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__